const DEFAULT_LOCALE = 'en-US';
const LOCALE_CODES = ['en-US', 'ja-JP', 'de-DE', 'es-ES', 'es-LA', 'fr-FR', 'it-IT', 'pt-BR', 'ko-KR', 'zh-CN', 'zh-TW', 'id-ID', 'pl-PL', 'th-TH', 'uk-UA', 'vi-VN'];

export { DEFAULT_LOCALE, LOCALE_CODES };
